<template>
  <!-- <div> -->
  <DBox
    :id="'cmp-settings-general-currencies'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')} ${$t('currency')}`"
    @add_click="onAddNewTerritory"
    :topRightMenu="[
      {
        html: helperText,
        icon: 'Help2.svg',
        value: 'question',
        cardStyle: {
          width: '300px'
        }
      }
    ]"
    :rightMenu="[
      {
        text: $t('update_exchange_rates'),
        value: 'update_exchange_rates'
      }
    ]"
    @menuClick="updateExchangeRates"
  >
    <NTable
      class="dbox1"
      :items="currencies"
      :config="tableConfig"
      :id="'settings-general-currencies'"
      :headers="headers"
      :showNoItems="false"
    >
      <template v-slot:thead="{ thcon, thtext }">
        <tr>
          <th v-bind="thcon('action')"><span>{{$t('iso')}}</span></th>
          <th v-bind="thcon('currency_name')">
            <span>{{ thtext("currency_name") }}</span>
          </th>
          <th v-bind="thcon('exchangerate')">
            <span>{{ thtext("exchangerate") }}</span>
          </th>
          <th v-bind="thcon('updated')">
            <span>{{ thtext("updated") }}</span>
          </th>
          <th v-bind="thcon('options')"></th>
        </tr>
      </template>
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('action')">
            <span>{{ item["currency_iso"] }}</span>
          </td>
          <td v-bind="tdcon('currency_name')">
            <span>{{ item["currency_name"] }}</span>
          </td>
          <td v-bind="tdcon('exchangerate')">
            <span>{{ item["exchange_rate"] }}</span>
          </td>
          <td v-bind="tdcon('updated')">
            <span>{{ getUpdated(item) }}</span>
          </td>
          <td v-bind="tdcon('options')">
            <div class="dt-icon-container">
              <img
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
                @click="e => onDeleteCurrency(item)"
                :alt="$t('delete_currency')"
                :title="$t('delete_currency')"
                v-if="item.is_deletable == 1"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
  <!-- <div>
      <div
        style="margin-left:auto;
                 margin-right:0px;
                 max-width:210px;
                 justify-content:right;
              
                 position: relative;
                 margin-top: -40px;
                "
        class="ut-flex"
        row
        justify-end
        px-1
      >
        <button class="dt-button v5 s5 " @click.stop="updateExchangeRates">
          Update Exchange Rates
        </button>
        <v-menu
          :close-on-content-click="false"
          open-on-hover
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <span slot="activator">
            <img
              src="static/icons/question-black.svg"
              class="dt-icon v5 s2 ut-center"
              style=" cursor: 'pointer'"
              alt=""
              title=""
              @mouseover="e => onFastHover()"
              @mouseleave="e => onFastLeave()"
            />
          </span>
          <div style="background-color: white;max-width:300px">
            <p style="padding:5px" v-html="helperText">.</p>
          </div>
        </v-menu>
      </div>
    </div> -->
  <!-- </div> -->
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";

import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "@/plugins/datatable";
import { distanceInWords } from "date-fns";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import { createTableHeader } from "../../../../plugins/datatable";
import { MHTTPCL } from "../../../../services/http/http-client";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
export default {
  components: {
    DBox,
    NTable
  },
  props: ["currencies"],
  data: function() {
    return {
      tableConfig: createNTableConfig({
        fullHeight: true,
        // headerStyle: 2,
        headerStyle: 3,
        rowHeight: 32
      })
    };
  },
  computed: {
    headers: function() {
      return [
        createTableHeader("action", { text: false }),
        createTableHeader("currency_name"),
        createTableHeader("exchangerate"),
        createTableHeader("updated"),
        createTableHeader("options", { mw: 40, text: false })
      ];
    },
    helperText: function() {
      //replace("$href$",`<a class="ut-link ut-text-accent5" href="${MHTTPCL.baseUrl}/${MHTTPCL.clientName}/v2/#/main/accounting/plugins">Plugins</a>`)
      const rawText = this.$t("settings_plugins_helper");
      return rawText.replace(
        "$href$",
        `<a class="ut-link ut-text-accent5" href="${MHTTPCL.baseUrl}/${
          MHTTPCL.clientName
        }/v2/#/main/accounting/plugins">Plugins</a>`
      );
    }
  },
  methods: {
    onFastHover: function() {},
    onFastLeave: function() {},
    onTerritoryDelete: function(item) {
      console.log("delete", item);
    },
    onAddNewTerritory: function() {
      this.$emit("add_new", true);
    },
    getUpdated: function(item) {
      const { created, last_modified } = item;
      //Temporary UTC Date Hack Solution. Would not work in every situation

      let date = new Date(last_modified);

      if (isNaN(date.getTime())) {
        date = new Date(created);
      }

      var utc = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

      return distanceInWords(utc, new Date());
    },
    updateExchangeRates: function() {
      this.$emit("update_exchr", true);
    },
    onDeleteCurrency:async function(item) {
      const confirmationResult = await confirmDelete(
        "Currency",
        item.currency_name
      );
      if (confirmationResult === "OK") {
        this.$emit('delete', item);
      }
      // ConfirmationService.create({
      //   subject: `Do you really want to delete the Currency ?`,
      //   model: true,
      //   width: 500,
      //   completed: res => {
      //     switch (res) {
      //       case "OK": {
      //         this.$emit("delete", item);
      //         break;
      //       }
      //     }
      //   }
      // });
    }

    //MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-settings-general-currencies {
  .dt-ntable {
    // --ntable-height: calc(100% - 70px);
    td.currency_iso {
      font-weight: 600;
    }
  }
}
</style>
